// extracted by mini-css-extract-plugin
export default {"main_div":"YogaModal_main_div__UITgN","error_msg":"YogaModal_error_msg__aGSz-","previewContainer":"YogaModal_previewContainer__oXRSE","previewImage":"YogaModal_previewImage__wmjxK"};